import React from "react";
import reactDOM from "react-dom";
import Documentation from "./components/Documentation";
import "./style.css"
 function App(){
    return(<>
    <Documentation/>
      
    </>
      
    )
 }
 export default App;